<template>
  <div
    class="report-scroll"
    :style="reportScrollStyle"
  >
    <div class="report-card">
      <div class="report-card-body">
      <div class="report-card-header">
        <div class="report-title-wrap">
          <div class="report-title-row">
            <div class="report-title-inner">
              <div class="report-title-logo-wrap">
                <img
                  class="report-title-logo"
                  :src="wxStatic('/static/image/programCode/logo.png')"
                 />
              </div>
              <span class="report-title">香味研究所鉴别报告</span>
            </div>
          </div>
          <div class="report-tonguo-badge report-tonguo-badge--header">
            <img
              class="report-tonguo-badge-img"
              :src="tonguoBadgeImageSrc"
             />
          </div>
        </div>
      </div>

      <div class="section section-opinion">
        <span class="section-label">鉴别意见</span>

        <div v-if="showOpinionDualColumn" class="opinion-dual-row">
          <div class="opinion-dual-col">
            <div class="opinion-dual-bar" />
            <div class="opinion-dual-body">
              <span class="opinion-dual-label">外观鉴别结果：</span>
              <span class="opinion-dual-desc">{{ appearanceOpinionDesc(splitAppearanceNum) }}</span>
              <span class="opinion-dual-verdict">{{ appearanceOpinionVerdict(splitAppearanceNum) }}</span>
            </div>
          </div>
          <div class="opinion-dual-col">
            <div class="opinion-dual-bar" />
            <div class="opinion-dual-body">
              <span class="opinion-dual-label">液体鉴别结果：</span>
              <span class="opinion-dual-desc">{{ liquidOpinionDesc(splitLiquidNum) }}</span>
              <span class="opinion-dual-verdict">{{ liquidOpinionVerdict(splitLiquidNum) }}</span>
            </div>
          </div>
        </div>

        <span v-else-if="showOpinionAppearanceCard" class="opinion-main">{{ appearanceOpinionMainSingle }}</span>
        <span v-else-if="showOpinionLiquidOnlyCard" class="opinion-main">{{ liquidOpinionMainSingle }}</span>
        <span v-else class="opinion-main">{{ opinionMain }}</span>
      </div>

      <div class="opinion-section-rule" />

      <div class="section section-divider">
        <span class="section-heading">样品基本信息</span>
        <div class="sample-info-row">
          <div class="sample-info-thumb-wrap">
            <img
              v-if="typeThumb"
              class="sample-info-thumb"
              :src="typeThumb"
            />
            <div v-else class="sample-info-thumb sample-info-thumb--ph">无图</div>
          </div>
          <div class="sample-info-list">
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">样品型号：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ modelLinePrimary }}</span>
                <span v-if="modelLineSecondary" class="sample-v sample-v--sub">{{ modelLineSecondary }}</span>
              </div>
            </div>
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">样品规格：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ sampleSpecificationDisplay }}</span>
              </div>
            </div>
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">样品批次：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ batchDisplay }}</span>
              </div>
            </div>
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">鉴别编号：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ identifyNoText }}</span>
              </div>
            </div>
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">订单编号：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ orderNoText }}</span>
              </div>
            </div>
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">接受样品日期：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ formatTime(sampleReceivedAtForReport) }}</span>
              </div>
            </div>
            <div class="sample-info-block sample-info-block--row">
              <span class="sample-k">鉴别完成时间：</span>
              <div class="sample-v-wrap">
                <span class="sample-v sample-v--muted">{{ formatTime(reportCompletedAtForReport) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section-divider sample-realpicture-section">
        <span class="section-heading">样品图片</span>
        <div v-if="noSamplePictures" class="sample-realpicture-empty">
          <span class="sample-realpicture-empty-txt">{{ samplePictureEmptyText }}</span>
        </div>
        <div v-else>
          <!-- 首图：实物图前 4 张 -->
          <div
            v-if="sampleMainPictureList.length"
            class="sample-realpicture-row sample-realpicture-row--fit4"
          >
            <div
              v-for="(url, idx) in sampleMainPictureList"
              :key="'sp-main-' + idx"
              class="sample-realpicture-cell sample-realpicture-cell--fit4"
            >
              <img
                v-if="url"
                class="sample-realpicture-img"
                :src="url"
               />
              <div v-else class="sample-realpicture-ph" />
            </div>
          </div>
          <!-- 第二行：实物图超出部分 + 细节图 + 余量图 -->
          <div v-if="hasSampleExtraPictures" class="sample-realpicture-extra">
            <div v-if="sampleExtraPictureOverflow" class="sample-realpicture-scroll-hint">
              <span class="sample-realpicture-scroll-hint-txt"
                >共 {{ sampleExtraPictureList.length }} 张，左右滑动查看更多</span
              >
            </div>
            <div
              v-if="!sampleExtraPictureOverflow"
              class="sample-realpicture-row sample-realpicture-row--fit4"
            >
              <div
                v-for="(url, idx) in sampleExtraPictureList"
                :key="'sp-extra-' + idx"
                class="sample-realpicture-cell sample-realpicture-cell--fit4"
              >
                <img
                  v-if="url"
                  class="sample-realpicture-img"
                  :src="url"
                 />
                <div v-else class="sample-realpicture-ph" />
              </div>
            </div>
            <div
              v-else
              class="sample-realpicture-scroll"
            >
              <div class="sample-realpicture-row sample-realpicture-row--scroll">
                <div
                  v-for="(url, idx) in sampleExtraPictureList"
                  :key="'sp-extra-s-' + idx"
                  class="sample-realpicture-cell sample-realpicture-cell--fixed"
                >
                  <img
                    v-if="url"
                    class="sample-realpicture-img"
                    :src="url"
                   />
                  <div v-else class="sample-realpicture-ph" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showInspectionChartsSection" class="section section-divider">
        <span class="section-heading">样品液体鉴别内容项</span>
        <div class="gc-block">
          <span class="gc-subtitle">· 标样气相色谱谱图</span>
          <div class="gc-chart-wrap">
            <img
              v-if="atlas2Url"
              class="gc-chart-img"
              :src="atlas2Url"
              @error="onAtlas2ImgError"
             />
            <div v-else class="gc-chart-ph">
              <span class="gc-chart-ph-txt">暂无谱图</span>
            </div>
          </div>
        </div>
        <div class="gc-block gc-block--last">
          <span class="gc-subtitle">· 样品气相色谱谱图</span>
          <div class="gc-chart-wrap">
            <div v-if="jbResultFail" class="gc-chart-secure">
              <span class="gc-chart-secure-txt">为保护数据安全，鉴别不通过，不提供样品谱图</span>
            </div>
            <img
              v-else-if="jbtpUrl"
              class="gc-chart-img"
              :src="jbtpUrl"
             />
            <div v-else class="gc-chart-ph">
              <span class="gc-chart-ph-txt">暂无谱图</span>
            </div>
          </div>
        </div>
      </div>

      <div class="report-qianming-wrap">
        <img
          class="report-qianming-img"
          :src="wxStatic('/static/image/programCode/qianMing.png')"
         />
      </div>

      <div class="section section-divider report-tips-section">
        <span class="report-tips-title">TIPS:</span>
        <span class="report-tips-line">本鉴别报告仅对委托商品负责，复印无效</span>
        <span class="report-tips-line">若实物鉴别的防伪贴纸损毁、涂改，此报告立即失效</span>
        <span class="report-tips-line">本报告不得擅自修改、增加或删除，否则一律无效</span>
        <span class="report-tips-line">本报告非CMA报告，不具备法律效力，不可作为司法用途</span>
        <span class="report-tips-line">本报告仅对该委托商品负责，不负责追溯该商品的来源</span>
        <span class="report-tips-line report-tips-line--last">如您对报告内容有疑问，请在报告出具后15日内反馈，逾期将不受理</span>
      </div>

      <div class="section section-divider program-cta-banner">
        <div class="program-cta-inner">
          <div class="program-cta-texts">
            <span class="program-cta-title">立即体验香味研究所鉴别服务</span>
            <span class="program-cta-desc">扫描右图中二维码，立即体验专业香水鉴别服务，新用户首单免费！</span>
          </div>
          <img
            class="program-cta-code"
            :src="wxStatic('/static/image/programCode/code.jpg')"
           />
        </div>
      </div>
      </div>
      <jb-report-watermark
        :text="watermarkDisplayText"
        :tile-count="240"
        :columns="6"
      />
    </div>
    <div class="report-scroll-end-gap" />
  </div>
</template>

<script>
import JbReportWatermark from "./JbReportWatermark.vue";
import * as Inv from "@/util/secondhandInspectionOpinion.js";
import { wxStaticUrl } from "@/util/wxStaticUrl.js";
import { absReportAssetUrl } from "@/util/reportAssetUrl.js";
import { formatSpecificationDisplay } from "@/util/specCapacityCompat.js";

export default {
  name: "JbReportNormal",
  components: {
    JbReportWatermark,
  },
  props: {
    orderData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      /** 标样谱图加载失败时依次尝试候选（有坐标优先，失败再无坐标） */
      atlas2ImgIndex: 0,
    };
  },
  watch: {
    orderData: {
      deep: true,
      handler() {
        this.atlas2ImgIndex = 0;
      },
    },
  },
  computed: {
    showOpinionDualColumn() {
      return Inv.showOpinionDualColumn(this.orderData);
    },
    splitAppearanceNum() {
      return Inv.splitAppearanceNum(this.orderData);
    },
    splitLiquidNum() {
      return Inv.splitLiquidNum(this.orderData);
    },
    showOpinionAppearanceCard() {
      return Inv.showOpinionAppearanceCard(this.orderData);
    },
    showOpinionLiquidOnlyCard() {
      return Inv.showOpinionLiquidOnlyCard(this.orderData);
    },
    appearanceOpinionMainSingle() {
      return Inv.appearanceOpinionDesc(this.singleAppearanceNum);
    },
    liquidOpinionMainSingle() {
      return Inv.liquidOpinionDesc(this.splitLiquidNum);
    },
    singleAppearanceNum() {
      return Inv.singleAppearanceNum(this.orderData);
    },
    /** 仅外观鉴别档：不展示液体谱图区块 */
    showInspectionChartsSection() {
      return !Inv.isAppOnlyInspectionService(this.orderData);
    },
    /** jbjg：0 假，1 真，NULL 未出结果（兜底，优先走 liquidOpinionMainSingle） */
    opinionMain() {
      if (!this.orderData) return "";
      const n = this.splitLiquidNum;
      if (n === 1) return Inv.liquidOpinionDesc(1);
      if (n === 2) return Inv.liquidOpinionDesc(2);
      return "—";
    },
    imagesObj() {
      return this.parseJsonField(this.orderData && this.orderData.images);
    },
    /** 型号图：接口 typeImage / typeImages，其次订单产品图 */
    typeThumb() {
      const d = this.orderData;
      if (!d) return "";
      const u = d.typeImage || d.typeImages || (this.imagesObj && this.imagesObj.img);
      return absReportAssetUrl(u);
    },
    modelLinePrimary() {
      const d = this.orderData;
      if (!d) return "—";
      const b = (d.brandName || "").trim();
      const t = (d.typeName || "").trim();
      if (b && t) return `${b} ${t}`;
      return b || t || "—";
    },
    modelLineSecondary() {
      const e = this.orderData && this.orderData.typeEnglishName;
      return (e && String(e).trim()) || "";
    },
    sampleSpecificationDisplay() {
      const d = this.orderData;
      if (!d) return "—";
      const text = formatSpecificationDisplay(d.specification);
      return text || "—";
    },
    batchEmphasis() {
      const b = this.orderData && this.orderData.batchNum;
      return !b || !String(b).trim();
    },
    batchDisplay() {
      return this.batchEmphasis
        ? "无（以最新批次进行比对）"
        : String(this.orderData.batchNum).trim();
    },
    /**
     * 鉴别编号：xw_order.identify_no（getJbdh 规则，如 10yyyyMMdd0001）。
     * 与 jb_code（内部鉴别号）不是同一字段，不可混用。
     */
    identifyNoText() {
      const d = this.orderData;
      if (!d) return "—";
      let v = d.identifyNo;
      if (v == null || String(v).trim() === "") {
        v = d.identify_no;
      }
      if (v != null && String(v).trim() !== "") return String(v).trim();
      return "—";
    },
    orderNoText() {
      return Inv.reportOrderNoText(this.orderData);
    },
    /** 水印鉴别编号数值（组件内加「鉴别编号：」前缀；为「—」时不铺水印） */
    watermarkDisplayText() {
      const t = this.identifyNoText;
      if (!t || t === "—") return "";
      return t;
    },
    /** 顶栏角标：外观/液体任一项不通过即展示不通过图；资源走 $wxStatic */
    tonguoBadgeImageSrc() {
      const fail = Inv.reportInspectionFailBadge(this.orderData);
      return fail
        ? wxStaticUrl("/report/jbbtg.png")
        : wxStaticUrl("/report/jbtg.png");
    },
    /** 优先展示 order.sampleReceivedAt（管理端录入），否则下单时间 */
    sampleReceivedAtForReport() {
      const d = this.orderData;
      if (!d) return null;
      const s = d.sampleReceivedAt;
      if (s != null && s !== "") return s;
      return d.createTime;
    },
    /** 鉴别完成时间：reportIssuedAt 优先，历史液体单无该字段时用 updateTime / createTime */
    reportCompletedAtForReport() {
      const d = this.orderData;
      if (!d) return null;
      const r = d.reportIssuedAt;
      if (r != null && r !== "") return r;
      if (d.updateTime != null && d.updateTime !== "") return d.updateTime;
      return d.createTime;
    },
    jbsxObj() {
      return this.parseJsonField(this.orderData && this.orderData.jbsx);
    },
    jbsxName() {
      const j = this.jbsxObj;
      return (j && (j.name || j.title)) || "";
    },
    /** 订单 realpicture：JSON 字符串或已解析对象 */
    realpictureObj() {
      const d = this.orderData && this.orderData.realpicture;
      if (d && typeof d === "object") return d;
      return this.parseJsonField(d);
    },
    /** 实物图列表 */
    realPictureList() {
      return this.collectPictureUrlsFromField(
        this.orderData && this.orderData.realpicture
      );
    },
    defectPictureList() {
      return this.collectPictureUrlsFromField(
        this.orderData && this.orderData.defectImgs
      );
    },
    remainPictureList() {
      return this.collectPictureUrlsFromField(
        this.orderData && this.orderData.remainImgs
      );
    },
    /** 首图：实物图前 4 张 */
    sampleMainPictureList() {
      return this.realPictureList.slice(0, 4);
    },
    /** 第二行：实物图超出部分 + 细节图 + 余量图 */
    sampleExtraPictureList() {
      return [
        ...this.realPictureList.slice(4),
        ...this.defectPictureList,
        ...this.remainPictureList,
      ];
    },
    hasSampleExtraPictures() {
      return this.sampleExtraPictureList.length > 0;
    },
    noSamplePictures() {
      return !this.sampleMainPictureList.length && !this.hasSampleExtraPictures;
    },
    samplePictureEmptyText() {
      return Inv.reportSamplePictureEmptyText(this.orderData, "normal");
    },
    /** 第二行超过 4 张时横向滑动并展示提示 */
    sampleExtraPictureOverflow() {
      return this.sampleExtraPictureList.length > 4;
    },
    /** 标样谱图候选：有坐标优先，无坐标兜底 */
    atlas2UrlCandidates() {
      const d = this.orderData || {};
      const typeObj = (d.type && typeof d.type === "object" ? d.type : {}) || {};
      return this.collectSpectrumChartCandidates(
        d.atlas2,
        typeObj.atlas2,
        d.atlas1,
        typeObj.atlas1
      );
    },
    /** 标样气相色谱谱图（优先有坐标，加载失败再退无坐标） */
    atlas2Url() {
      const list = this.atlas2UrlCandidates;
      const i = Math.min(this.atlas2ImgIndex, Math.max(0, list.length - 1));
      return list[i] || "";
    },
    /** 样品气相色谱谱图 */
    jbtpUrl() {
      const u = this.orderData && this.orderData.jbtp;
      return absReportAssetUrl(u);
    },
    /** 液体不通过仍展示样品谱图；仅外观鉴别档不展示 */
    jbResultFail() {
      return Inv.shouldHideSampleIdentifyChart(this.orderData);
    },
    reportScrollStyle() {
      return {
        backgroundImage: `url("${wxStaticUrl("/static/image/report/black-background.png")}")`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
      };
    },
  },
  methods: {
    wxStatic(path) {
      return wxStaticUrl(path);
    },
    /** 同一文件的有坐标/无坐标版本互备，且优先有坐标版 */
    collectSpectrumChartCandidates(...values) {
      const seen = new Set();
      const out = [];
      const pushWithVariants = (raw) => {
        if (raw == null || raw === "") return;
        const resolved = absReportAssetUrl(raw);
        if (!resolved) return;
        const variants = [resolved];
        if (/_NoXY\.png$/i.test(resolved)) {
          variants.unshift(resolved.replace(/_NoXY\.png$/i, ".png"));
        } else if (/\.png$/i.test(resolved) && !/_NoXY/i.test(resolved)) {
          variants.push(resolved.replace(/\.png$/i, "_NoXY.png"));
        }
        for (const v of variants) {
          if (v && !seen.has(v)) {
            seen.add(v);
            out.push(v);
          }
        }
      };
      for (const u of values) {
        pushWithVariants(u);
      }
      out.sort((a, b) => {
        const aNo = /_NoXY/i.test(a) ? 1 : 0;
        const bNo = /_NoXY/i.test(b) ? 1 : 0;
        return aNo - bNo;
      });
      return out;
    },
    onAtlas2ImgError() {
      if (this.atlas2ImgIndex < this.atlas2UrlCandidates.length - 1) {
        this.atlas2ImgIndex += 1;
      }
    },
    appearanceOpinionDesc(n) {
      return Inv.appearanceOpinionDesc(n);
    },
    appearanceOpinionVerdict(n) {
      return Inv.appearanceOpinionVerdict(n);
    },
    liquidOpinionDesc(n) {
      return Inv.liquidOpinionDesc(n);
    },
    liquidOpinionVerdict(n) {
      return Inv.liquidOpinionVerdict(n);
    },
    parseJsonField(str) {
      if (str == null || str === "") return null;
      if (typeof str === "object") return str;
      if (typeof str !== "string") return null;
      try {
        return JSON.parse(str);
      } catch (e) {
        return null;
      }
    },
    /** 解析 JSON 数组 / urls / img1～imgN 为绝对 URL 列表 */
    collectPictureUrlsFromField(raw) {
      const urls = [];
      const add = (u) => {
        const resolved = absReportAssetUrl(u);
        if (resolved && !urls.includes(resolved)) urls.push(resolved);
      };
      let obj = raw;
      if (obj != null && typeof obj !== "object") {
        obj = this.parseJsonField(obj);
      }
      if (obj == null) return urls;
      if (Array.isArray(obj)) {
        obj.forEach(add);
        return urls;
      }
      if (typeof obj !== "object") return urls;
      if (Array.isArray(obj.urls) && obj.urls.length) {
        obj.urls.forEach(add);
        return urls;
      }
      [
        "img1",
        "img2",
        "img3",
        "img4",
        "img5",
        "img6",
        "img7",
        "img8",
      ].forEach((k) => add(obj[k]));
      return urls;
    },
    formatTime(val) {
      if (val == null || val === "") return "—";
      let ms = val;
      if (typeof val === "number") {
        ms = val < 1e12 ? val * 1000 : val;
      } else if (typeof val === "string" && /^\d+$/.test(val.trim())) {
        const n = Number(val.trim());
        ms = n < 1e12 ? n * 1000 : n;
      }
      const d = new Date(ms);
      if (Number.isNaN(d.getTime())) return String(val);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const h = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${y}/${m}/${day} ${h}:${min}`;
    },
  },
};
</script>

<style scoped>
.report-scroll {
  height: 100%;
  min-height: 480px;
  box-sizing: border-box;
  overflow-y: auto;
}

.report-scroll-end-gap {
  height: 15px;
  width: 100%;
  flex-shrink: 0;
}

.report-card {
  position: relative;
  margin: 97.5px 12px 0;
  padding-top: 20px;
  padding-bottom: 24px;
  background: #fff;
  border-radius: 0;
  /* 裁剪到白卡片内；斜向水印层会略超出边框，由卡片裁切，避免叠到外层 scroll 黑底 */
  overflow: hidden;
}

.report-card-body {
  position: relative;
  z-index: 1;
}

.report-card-header {
  width: 100%;
  box-sizing: border-box;
  background-color: #ffffff;
}

/* 角标绝对定位于标题区右下，不参与标题 flex（与 jb-report-secondhand 一致） */
.report-title-wrap {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

/* 透明底章：正方形占位 + aspectFit */
.report-tonguo-badge {
  width: 66px;
  height: 66px;
  z-index: 2;
  background: transparent;
  padding: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  flex-shrink: 0;
}

.report-tonguo-badge--header {
  position: absolute;
  right: -5px;
  bottom: -50px;
  width: 104px;
  height: 104px;
  transform: rotate(-20deg);
  transform-origin: center center;
}

.report-tonguo-badge-img {
  width: 66px;
  height: 66px;
  display: block;
}

.report-tonguo-badge--header .report-tonguo-badge-img {
  width: 130px;
  height: 130px;
}

.report-title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 14px 12px;
}

.report-title-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 100%;
}

.report-title-logo-wrap {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  margin-right: 8px;
  border-radius: 50%;
  overflow: hidden;
  background: #f3f0f7;
}

.report-title-logo {
  width: 100%;
  height: 100%;
  display: block;
}

.report-title {
  flex: 1;
  min-width: 0;
  font-size: 21px;
  font-weight: 700;
  color: #111;
  line-height: 1.35;
  text-align: left;
}

.section {
  padding: 14px 14px 4px;
}

.section-opinion {
  text-align: left;
}

/* 鉴别意见下方横线：左右缩进不与卡片边缘对齐 */
.opinion-section-rule {
  height: 0.5px;
  margin: 6px 14px 0 14px;
  background: #e8e8e8;
}

.section-label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
  text-align: left;
}

/* 「鉴别意见」与顶栏主文案左缘对齐（抵消 .section 左右 14px，再与 report-hero 左 16px 对齐） */
.section-opinion .section-label {
  margin-left: -14px;
  padding-left: 16px;
  text-align: left;
}

.section-opinion .opinion-main {
  text-align: center;
}

.opinion-main {
  display: block;
  font-size: 20px;
  font-weight: bold;
  color: #111;
  line-height: 1.6;
}

.opinion-dual-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 10px;
  padding: 4px 0 2px;
}

.opinion-dual-col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.opinion-dual-bar {
  width: 3px;
  flex-shrink: 0;
  margin-right: 7px;
  border-radius: 1.5px;
  background: #000000;
}

.opinion-dual-body {
  flex: 1;
  min-width: 0;
}

.opinion-dual-label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #111;
  line-height: 1.45;
  margin-bottom: 5px;
}

.opinion-dual-desc {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: #333;
  line-height: 1.5;
  margin-bottom: 6px;
}

.opinion-dual-verdict {
  display: block;
  font-size: 23px;
  font-weight: 700;
  color: #111;
  line-height: 1.25;
}

.section-divider {
  padding-top: 14px;
}

.section-heading {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 12px;
}

.sample-info-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.sample-info-thumb-wrap {
  flex-shrink: 0;
  align-self: stretch;
  width: 100px;
  min-height: 130px;
  margin-right: 12px;
  border-radius: 6px;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sample-info-thumb {
  width: 100px;
  height: 100%;
  min-height: 130px;
  display: block;
  object-fit: contain;
  background: #ffffff;
}

.sample-info-thumb--ph {
  width: 100px;
  height: 100%;
  min-height: 130px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #9ca3af;
}

.sample-info-list {
  flex: 1;
  min-width: 0;
}

.sample-info-block {
  margin-bottom: 10px;
}

.sample-info-block:last-child {
  margin-bottom: 0;
}

.sample-info-block--row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.sample-info-block--row .sample-k {
  flex-shrink: 0;
  width: auto;
  margin-bottom: 0;
  margin-right: 2px;
  line-height: 1.45;
  white-space: nowrap;
}

.sample-v-wrap {
  flex: 1;
  min-width: 0;
}

.sample-k {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #111;
}

.sample-v {
  display: block;
  font-size: 13px;
  line-height: 1.45;
  word-break: break-all;
}

.sample-v--sub {
  color: #666666;
  font-size: 12px;
  margin-top: 3px;
  font-weight: 400;
}

.sample-v--muted {
  color: #666666;
  font-weight: 400;
}

.sample-v--strong {
  color: #111;
  font-weight: 700;
}

.sample-realpicture-empty {
  padding: 4px 0 2px;
}

.sample-realpicture-empty-txt {
  font-size: 13px;
  color: #666666;
  line-height: 1.55;
}

.sample-realpicture-section .section-heading {
  margin-bottom: 6px;
}

.sample-realpicture-scroll-hint {
  margin-top: -5px;
  padding: 0 0 4px;
}

.sample-realpicture-scroll-hint-txt {
  font-size: 12px;
  color: #888888;
  line-height: 1.45;
}

.sample-realpicture-extra {
  margin-top: 8px;
}

.sample-realpicture-row--fit4 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
}

.sample-realpicture-cell--fit4 {
  flex: 0 0 calc((100% - 18px) / 4);
  width: calc((100% - 18px) / 4);
  max-width: calc((100% - 18px) / 4);
  height: 84px;
  border-radius: 5px;
  overflow: hidden;
  background: #f3f4f6;
  box-sizing: border-box;
}

.sample-realpicture-scroll {
  width: 100%;
  white-space: nowrap;
  box-sizing: border-box;
  overflow-x: auto;
}

.sample-realpicture-row--scroll {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 6px;
  padding-bottom: 2px;
  box-sizing: border-box;
}

.sample-realpicture-cell--fixed {
  flex: 0 0 calc((375px - 70px) / 4);
  width: calc((375px - 70px) / 4);
  min-width: calc((375px - 70px) / 4);
  max-width: calc((375px - 70px) / 4);
  height: 84px;
  border-radius: 5px;
  overflow: hidden;
  background: #f3f4f6;
  box-sizing: border-box;
}

.sample-realpicture-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 6px;
}

.sample-realpicture-cell {
  flex: 1;
  min-width: 0;
  height: 84px;
  border-radius: 5px;
  overflow: hidden;
  background: #f3f4f6;
}

.sample-realpicture-img {
  width: 100%;
  height: 100%;
  display: block;
}

.sample-realpicture-ph {
  width: 100%;
  height: 100%;
  background: #eceef0;
}

.gc-block {
  margin-bottom: 16px;
}

.gc-block--last {
  margin-bottom: 0;
}

.gc-subtitle {
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #888888;
  margin-bottom: 8px;
  line-height: 1.4;
}

.gc-chart-wrap {
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  background: #ffffff;
}

.gc-chart-secure {
  padding: 18px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.gc-chart-secure-txt {
  font-size: 13px;
  color: #666666;
  line-height: 1.55;
  text-align: center;
}

.gc-chart-img {
  width: 100%;
  display: block;
}

.gc-chart-ph {
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #ffffff;
}

.gc-chart-ph-txt {
  font-size: 12px;
  color: #9ca3af;
}

.report-qianming-wrap {
  padding: 12px 14px 4px;
  box-sizing: border-box;
}

.report-qianming-img {
  width: 100%;
  display: block;
}

.report-tips-section {
  padding-bottom: 16px;
}

.report-tips-title {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #111111;
  letter-spacing: 0.02em;
  margin-bottom: 12px;
}

.report-tips-line,
.program-cta-desc {
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  line-height: 1.55;
}

.report-tips-line {
  display: block;
  text-align: left;
  margin-bottom: 8px;
}

.report-tips-line--last {
  margin-bottom: 0;
}

.program-cta-banner {
  padding-bottom: 20px;
}

.program-cta-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.program-cta-texts {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.program-cta-title {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #111111;
  line-height: 1.4;
  margin-bottom: 8px;
}

.program-cta-desc {
  display: block;
}

.program-cta-code {
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/jbReport/JbReportNormal.vue